import { Injectable } from '@angular/core';
import { PaginatorResponse, ResponseData } from '@klickdata/core/http';
import { Notification, NotificationData, NotificationService } from '@klickdata/core/notification';
import { TableHttpHelpers, TableHttpService, TableSource } from '@klickdata/core/table';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class NotificationListingService extends NotificationService implements TableHttpService<Notification> {
    public fetchData(source: TableSource<Notification>): Observable<ResponseData<Notification[]>> {
        const req = this.builder.get<NotificationData[]>(this.notificationUrl);

        TableHttpHelpers.managePagination(source.paginator, req);
        TableHttpHelpers.manageSort(source.sort, req);
        TableHttpHelpers.mapFilter(source.filter, req);

        return req.request().pipe(
            map((res: PaginatorResponse<NotificationData[]>) => {
                return {
                    data: res.data.map((notification) => this.mapNotification(notification)),
                    notify: res.notify,
                    more: res.more,
                    paginator: res.paginator,
                };
            })
        );
    }
}
